import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { Global } from '@emotion/react';
import { createBaseStyles } from './BaseStylesService';
export const BaseStyles = () => (_jsx(Global, { styles: (theme) => createBaseStyles({ theme }) }));
